module.exports = __webpack_public_path__ + "assets/img/3_1345_big.98bea2de.jpg";